import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import BugReportIframe from '../utils/BugReportIframe';

const NotFound = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleReportProblem = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-8">
        {/* Image */}
        <div className="text-9xl font-bold text-gray-300 mb-4">404</div>

        {/* Error Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4 text-center">
          Oops! Wrong Page.
        </h1>
        <p className="text-gray-600 text-center mb-8 max-w-md">
          We couldn't find the page you're looking for. Let's get you back on track to official election information.
        </p>
        
        {/* Go Back Home Button */}
        <button
          onClick={handleGoBack}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-lg transition-colors mb-4"
        >
          <ArrowBackIcon fontSize="small" />
          Go back
        </button>

        {/* Report a Problem Link */}
        <button
          onClick={handleReportProblem}
          className="text-blue-600 hover:text-blue-700 text-sm font-medium"
        >
          Report a problem
        </button>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-200 p-4">
        <div className="max-w-6xl mx-auto space-y-2 text-xs text-gray-500">
          <div className="flex flex-wrap justify-center gap-4 mb-2">
            <span className="hover:text-gray-700 cursor-pointer">Privacy Policy</span>
            <span className="hover:text-gray-700 cursor-pointer">Terms of Service</span>
            <span className="hover:text-gray-700 cursor-pointer">Contact Us</span>
          </div>
          <div className="text-center">
            <p>123Vote is a civic engagement platform. We do not endorse or oppose candidates, parties, or ballot measures.</p>
            <p className="mt-1">© 2024 123Vote. All rights reserved.</p>
            <p className="mt-1">Secure Official Channel for Election Information</p>
          </div>
        </div>
      </footer>

      {/* Bug Report Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">Report a Problem</h2>
              <button
                onClick={handleCloseModal}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <CloseIcon />
              </button>
            </div>
            <div className="p-4">
              <BugReportIframe />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotFound;
